'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './SideText.module.scss'
import { useRef } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Body } from '@/types/common/Body'
import { Image } from '@/types/common/ImageData'
import { portableBlockComponents } from "@/utils/portableText";
import { PortableText } from "@portabletext/react";
import usePinShorterColumn from '@/utils/usePinShorterColumn'

interface SideTextProps {
    data: DataProps
}

interface ImageProp {
    image: Image;
}

interface DataProps {
    _type: string;
    _ref: string;
    content: Body[] | null;
    gallery: Array<Image>;
    borderTop: boolean | null;
}

const hasFootnotes = (content: any): boolean => {
    // Verificar si content está definido y es un array
    if (!Array.isArray(content)) {
      return false;
    }
  
    // Buscar footnotes en el contenido
    return content.some((block: any) => {
      if (block._type === "block" && block.markDefs) {
        return block.markDefs.some((def: any) => def._type === "footnote");
      }
      return false;
    });
};

export default function SideTextComponent({
data
}: SideTextProps) {

    const hasAnyFootnotes = hasFootnotes(data.content);
    const textRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const galleryRef = useRef<HTMLDivElement>(null);

    usePinShorterColumn(textRef, galleryRef);

    return (
        <div ref={containerRef} className={`${s.sideText} ${hasAnyFootnotes ? s.footnotes : ""}`}>
            <div ref={textRef} className={`${s.text}`}>
                <div className={`${data.borderTop ? s.borderTop : ""}`}></div>
                {data.content &&
                    <PortableText
                        value={data.content}
                        components={portableBlockComponents(data.content)}
                    />
                }
            </div>
            <div ref={galleryRef} className={`${s.gallery} ${hasAnyFootnotes ? s.footnotes : s.noFootnotes}`}>
                {data.gallery && data.gallery.map((image, index) => {
                    return (
                        <div key={index} className={s.image}>
                            <LazyImage
                                src={image.imageUrl}
                                width={image.metadata.dimensions.width}
                                height={image.metadata.dimensions.height}
                                blurDataURL={image.ref}
                                fill={false}
                                alt={image.attribution || ""}
                                caption={image.caption || null}
                                filename={image.filename || ""}
                            />
                        </div>
                    )
                })}

            </div>
        </div>
    )
}
